import React, { useState,useEffect } from 'react';
import * as HELPER from "@src/config/helper";
import Pagination from '@src/common/Pagination';
import ConfirmPopUp from '../common/ConfirmPopUp';
import { toast } from 'react-toastify';
import { PaymentApproveReject,AssignPayment } from '@src/store/slices/reconciliation';
import { ROLE_FEATURES,MANAGER_LEVEL_IDS } from "../config/ph/constant";
import secureStorage from '../../src/config/encrypt';
import Select from 'react-select';

type OptionType = {
  value: number;
  label: string;
};


interface PaymentTableProps {
  paymentList: any[];
  paginationData: any;
  getPaymentListing: (params: any) => void;
  selectedFilters: any;
  paymentTypeList: any;
  reasonList: any;
  assignUsers:any;
  selectedLeads:any;
  setSelectedLeads:(params: any) => void;
  setIsAllLeadsSelected:(params: any) => void;
}

const PaymentListTable: React.FC<PaymentTableProps> = ({
  paymentList,
  paginationData,
  getPaymentListing,
  selectedFilters,
  paymentTypeList,
  reasonList,
  assignUsers,
  selectedLeads,
  setSelectedLeads,
  setIsAllLeadsSelected
}) => {
  // eslint-disable-next-line
  let [loading, setLoading] = useState(false);
  const [selectedReason, setSelectedReason] = useState<OptionType | null>(null);
  const [modalVisible, setModalVisible] = useState<string | null>(null);
  const [currentObj, setCurrentObj] = useState<any>(null);
  const page = 1;
  const authUserInfo = secureStorage.getItem("authUserInfo");
  const [leadListData, setLeadListData] = useState<any>([]);
  const [showSelectedAssignSave, setShowSelectedAssignSave] = useState(0);

   useEffect(() => {
      setLeadListData(paymentList);
    }, [paymentList])

  const handleRequestData = (params: any) => {
    let apiParams = {
        ...selectedFilters,
        page_number: params.page_no
    }
    getPaymentListing(apiParams)
  }

  const ShowRejectModel = (type: string, currentObj: any) => {
          setModalVisible(type);
          setCurrentObj(currentObj)
      };
  
      const handleReasonChange = (selectedOption: OptionType | null) => {
          setSelectedReason(selectedOption);
      };
  
      const confirmYes = async () => {
          let id  = currentObj ? currentObj.id : '';
          if(id === '') return;
          let updateObject:any;
          if(modalVisible === "approve_cheque"){
            updateObject = {
                id: id,
                status : 1,
                type : "approve_cheque",
                page: 'finance',
            };
          }else{
            updateObject = {
                id: id,
                reason_id: selectedReason,
                type: modalVisible === 'reject' ? 'reject' : 'approve',
                page: 'finance',
                status:  modalVisible === 'approve' ? 1 : 2
            };
          }
          
          setLoading(true)
          PaymentApproveReject(updateObject).then((res: any) => {
              setLoading(false)
              if (res && res.status === 200) {
                  toast.success(res.message);
                  if(modalVisible === "approve" || modalVisible === 'reject'){
                    if(currentObj) {
                        currentObj.finance_status = updateObject.status
                    }
                  }
                  handleRequestData({page_no: 1});
                  setLoading(false)
              }
          }).catch(err => setLoading(false))
         confirmNo();
      };
  
      const confirmNo = () => {
          setSelectedReason(null)
          setModalVisible(null);
          setCurrentObj(null)
      };


  // const getPaymentType = (type: number | string, paymentList: OptionType[]) => {
  //   const label = paymentList.find(item => item.value === type)?.label || '';
  //   return label;
  // }

  // Function to calculate due date class
  const getDueDateClass = (lead: any): string => {
    const dueDate = new Date(lead?.due_date);
    const payementDate = new Date(lead?.transaction_date);

    if (!lead?.due_date) return "";

    // Normalize times for accurate date-only comparison
    const due = new Date(dueDate.setHours(0, 0, 0, 0));
    const payment = new Date(payementDate.setHours(0, 0, 0, 0));

    const diffInDays = (due.getTime() - payment.getTime()) / (1000 * 60 * 60 * 24);

    if (diffInDays < 0) return "txt-highlight"; // Past due
    if (diffInDays <= 14) return "txt-yellow";  // Due within next 14 days

    return "";
  };

  const handleChangeAssign = (leadId: any, e: any) => {
    setLeadListData(paymentList.map((u: any) => { return (u.id === leadId) ? { ...u, 'assigned_finance_id': e.value } : u }));
    setShowSelectedAssignSave(leadId);
  }

  const getSelectedAssignUser = (id: any) => {      
    let getSelectedUser = assignUsers.find((u: any) => +u.value === +id);
    return getSelectedUser || null;
  }

  const saveAssignLeadHandler = (params: { id: string, action: string }) => {
    if (params.action === "cancel") {
        setShowSelectedAssignSave(0);
        setLeadListData([...paymentList])
    } else {
        let getLead: any = leadListData.find((ins: any) => ins.id === params.id) || {};
        AssignPayment({ payment_id: params.id, "assigned_user_id": getLead['assigned_finance_id'],user_type:'assigned_finance_id' }).then((res: any) => {
            if(res && res.status === 200) {
              handleRequestData({page_no: 1});                              
              setShowSelectedAssignSave(0)
            }
        }).catch(err => {

        })
    }
  }

  // Handle select all checkbox
    const handleSelectAll = (isChecked: boolean) => {
        if (isChecked) {
            // select all
          const allSelected: any[] = leadListData.map((lead: any) => ({
              id: lead.id
          }));
          setSelectedLeads(allSelected);
      } else {
          // unselect all
          setSelectedLeads([]);
      }
  };
  // Handle individual checkbox change
  const handleItemSelect = (lead: { id: number},isChecked: boolean): void => {
      if (isChecked) {
          setSelectedLeads((prev:any) => [
              ...prev,
              {
                id: lead.id,
              },
          ]);
      } else {
          setSelectedLeads((prev:any) =>
              prev.filter(
                  (item:any) =>
                  !(
                      item.id === lead.id
                  )
              )
          );
      }
  }
  const isAllSelected = leadListData.length > 0 && selectedLeads.length === leadListData.length;
  setIsAllLeadsSelected(isAllSelected);
  return (
    <div className='data-table  payment-verification-table-data'>
      <table>
        <thead>
          <tr>
            {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && 
              <th>
                <input
                    type="checkbox"
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    style={{ cursor: 'pointer' }}
                    checked={isAllSelected}
                />
              </th>
            }
            <th style={ !MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) ? { width: 'auto' } : {}}>Policy No.</th>
            <th>Customer Details</th>
            <th>Payment Amount</th>
            <th>Due Date</th>
            <th>Method</th>
            <th>Proof</th> 
            {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) &&<th>Assigned to</th>}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {
              leadListData.length
                  ?
              leadListData.map((list: any, key: number) =>
              <tr key={key}>
                {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && 
                 <td>
                      <input
                          type="checkbox"
                          onChange={(e) => handleItemSelect({id: list.id}, e.target.checked)}
                          style={{ cursor: 'pointer' }}
                          checked={selectedLeads.some((item:any) => item.id === list.id)}
                      />
                  </td>
                }
                <td><span className='truncate' title={list?.policy_no}>{list?.policy_no} </span></td>
                <td>

                  <span className='truncate t-bold' title={list?.customer_name}>{list?.customer_name || ''}</span>
                  <span className='d-block'>{list?.customer_mobile || ''}</span>

                </td>
                <td>
                  {<td>{HELPER.addCurrencyFormatting(list.amount) || 0}</td>}
                </td>
                <td>
                  <span className={getDueDateClass(list)}>
                    {/* {dateFormat(list.due_date, 'UTC:dd mmm yyyy')} */}
                    {list.due_date}
                  </span>
                </td>
                <td>
                   <span>{list.cheque_no ? 'Cheque': '-'}</span>
                  <span className='truncate' title={list.cheque_no}>Cheque No. {list.cheque_no || '-'}</span> 
                  {/* <span>{getPaymentType(list.payment_type, paymentTypeList)}</span> */}
                  {/* {list.payment_type == 1 &&<span>No - {list.cheque_no || '-'}</span> } */}
                </td>
                <td>{list.payment_proof !== "" ? 'Attached' : 'Not Attached'} 
                    {
                      list.payment_proof !== ""
                       &&
                      <a 
                        href={list.payment_proof} 
                       // download
                        target="_blank"  
                        rel="noopener noreferrer"
                        className="download-link" 
                        title="Download Payment Proof"
                        style={{ textDecoration: 'none' }}
                      >
                        <i className='ic-attach_file'></i>
                      </a>
                    }
                </td> 
                {
                  (MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids)) &&
                  <td>
                    <div className="select-table">
                      <fieldset className="single-select assigned-to-select reco-assign-user-list">
                        <div className="material table-select-box__placeholder">
                          <Select
                              value={getSelectedAssignUser(list.assigned_finance_id)}
                              options={assignUsers}
                              onChange={(e) => handleChangeAssign(list.id, e)}
                              placeholder="Assign To"
                              styles={{
                                  option: (provided) => ({
                                      ...provided,
                                      whiteSpace: 'normal',
                                      wordWrap: 'break-word',
                                      wordBreak: 'break-word'
                                  })
                              }}
                          />
                          {
                            showSelectedAssignSave === list.id &&
                            <div className="amt-edit-opt"><button className="btn-primary" onClick={() => saveAssignLeadHandler({ id: list.id, action: 'save' })}>Save</button><i className="ic-clearclose" onClick={() => saveAssignLeadHandler({ id: list.id, action: 'cancel' })}></i></div>
                          }
                        </div>
                      </fieldset>
                    </div>
                  </td>
                }
                <td>
                  <ul>
                      {
                        HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['Finance'], accessType: 'edit' }) ?

                          <ul className="action-btn">
                            {/* Approve Button */}
                            {
                              list.cheque_verify === 0 ? 
                                <li
                                  className={`${list.finance_status === 1 ? 'verfied-icn' : ''}`}
                                  title={`${list.finance_status === 1 ? 'Verfied' : 'Verify'}`}
                                  onClick={() => {
                                    if (list.finance_status === 1 || list.finance_status === 2) return;
                                    ShowRejectModel('approve_cheque', list);
                                  }}
                                >
                                  <i className="ic-check"></i>
                                </li>
                              :
                              <>
                              <span className={(list.finance_status === 1 || list.finance_status === 2) ? `payment-received payment-received-done` : `payment-received`} onClick={() => {
                                     if (list.finance_status === 1 || list.finance_status === 2) return;
                                     ShowRejectModel('approve', list);
                                   }}>Approve</span>
                              </>
                                // <li
                                //   className={`${list.finance_status == 1 ? 'verfied-icn' : ''}`}
                                //   title={`${list.finance_status == 1 ? 'Verfied' : 'Verify'}`}
                                //   onClick={() => {
                                //     if (list.finance_status == 1 || list.finance_status == 2) return;
                                //     ShowRejectModel('approve_cheque', list);
                                //   }}
                                // >
                                //   <i className="ic-check"></i>
                                //   <span>Payment Received</span>
                                // </li>
                            }

                            {/* Reject Button */}
                            <li
                              className={`${list.finance_status === 2 ? 'rejected-icn' : ''}`}
                              title={`${list.finance_status === 2 ? 'Rejected' : 'Reject'}`}
                              onClick={() => {
                                if (list.finance_status === 1 || list.finance_status === 2) return;
                                ShowRejectModel('reject', list);
                              }}
                            >
                              <i className="ic-clearclose"></i>
                            </li>
                          </ul>
                          : ''
                      }
                  </ul>
                </td>
              </tr>
             )

              :
              <tr><td colSpan={7} style={{ textAlign: 'center' }}>No data found</td></tr>

            }
        </tbody>
      </table>
        {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
          page,
          loading: false,
          totalLengthWithoutPagination: paginationData['total'],
          paginationData,
          filteredData: selectedFilters
        }}
        sendRequestDataToParent={handleRequestData} />}

        {modalVisible === 'reject' && (
            <ConfirmPopUp
              confirmNo={confirmNo}
              confirmYes={confirmYes}
              isReasonVisible={true}
              reasonList = {reasonList}
              handleChange={handleReasonChange}
              selectedReason={selectedReason}
              placeholder= "Select Reason"
              isConfirmNotVisible={true}
              // message={translations.RuleEngine?.['Delete_Role_Msg'] || translations.commonMsg?.loading} />
              message="Are You Sure, You Want To Reject This Payment?" />
        )}

        {modalVisible === "approve" && (
            <ConfirmPopUp
                confirmNo={confirmNo}
                confirmYes={confirmYes}
                isConfirmNotVisible={true}
                message="Are You Sure, You Want To Verify This Payment?"
            />
        )}

        {modalVisible === "approve_cheque" && (
            <ConfirmPopUp
                confirmNo={confirmNo}
                confirmYes={confirmYes}
                isConfirmNotVisible={true}
                message="Are You Sure, You Want To Verify This Cheque?"
            />
        )}
    </div>
  )
}

export default PaymentListTable;